var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.computedHeader.length)?_c('RecyclerDataTable',{attrs:{"headers":_vm.computedHeader,"items":_vm.tableData,"key_field":'sensor_time'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }